<div class="reset-password" [style.background-image]="backgroundUrlImageUrl">
  <div class="reset-password-content">
    <mat-card>
      <mat-card-header>
        <mat-card-title class="mat-card-title">
          <img
            class="wk-reset-password-logo"
            alt="Alfresco, make business flow"
            src="./assets/images/alfresco-logo.svg"
          />
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <h2 class="title">{{ 'RESET_PASSWORD.TITLE' | translate }}</h2>
        <p class="description">{{ 'RESET_PASSWORD.DESCRIPTION' | translate }}</p>
        <div
          class="error-container"
          *ngIf="failed || (submitted && formGroup.invalid)"
        >
          <mat-icon
            class="mat-icon notranslate material-icons mat-icon-no-color"
            aria-hidden="true"
            data-mat-icon-type="font"
          >
            warning
          </mat-icon>
          <div>
            <span *ngIf="formGroup.controls.email.errors?.required">
              {{ 'RESET_PASSWORD.ERRORS.REQUIRED' | translate }}
            </span>
            <span *ngIf="formGroup.controls.email.errors?.email">
              {{ 'RESET_PASSWORD.ERRORS.NOT_AN_EMAIL' | translate }}
            </span>
            <span *ngIf="failed">
              {{ 'RESET_PASSWORD.ERROR_RESPONSES.' + failMessage | translate }}
            </span>
          </div>
        </div>
        <p class="success" *ngIf="success">
          {{ 'RESET_PASSWORD.SUCCESS' | translate }}
        </p>
        <form [formGroup]="formGroup" (submit)="onSubmit()">
          <mat-form-field color="primary" class="wk-email-field">
            <input
              matInput
              type="email"
              autocomplete="off"
              formControlName="email"
              placeholder="{{ 'RESET_PASSWORD.PLACEHOLDER' | translate }}"
            />
          </mat-form-field>
          <button
            class="wk-submit-button"
            mat-raised-button
            color="accent"
            [disabled]="isDisabled"
          >
            {{ 'RESET_PASSWORD.BUTTON' | translate }}
          </button>
          <a
            class="return-to-login"
            [routerLink]="['/login']"
            [queryParams]="{ useSso: false }"
          >
            {{ 'APP.RETURN_TO_LOGIN' | translate }}
          </a>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="copyright">
    {{ 'APP.COPYRIGHT' | translate }}
  </div>
</div>
